/**
 * Tiny fetch hook — GET only. Tracks data/loading/error and re-fetches when
 * the endpoint changes or refresh() is called.
 */
import { useCallback, useEffect, useState } from 'react'
import { apiCall } from './api'

export function useApi(endpoint, { enabled = true } = {}) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(enabled)
  const [error, setError] = useState(null)
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (!enabled || !endpoint) {
      setLoading(false)
      return
    }
    let cancelled = false
    setLoading(true)
    apiCall(endpoint)
      .then((json) => {
        if (!cancelled) {
          setData(json)
          setError(null)
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [endpoint, enabled, tick])

  const refresh = useCallback(() => setTick((t) => t + 1), [])

  return { data, loading, error, refresh }
}
